export default __webpack_public_path__ + "static/media/favicon.e1c30975.ico";